export default __webpack_public_path__ + "images/8f8ed7237e30e77513d6ca7a67606b31.svg";